import React from "react";
import type {
	AiAssistantControllerValue,
} from "src/components/views/ai/assistant/controller/useAiAssistantController.ts";
import { useContextOrThrow } from "src/utils/useContextOrThrow.tsx";

export interface AiAssistantControllerContextValue extends AiAssistantControllerValue {
	askInFirstExistingThread: (userInput: string) => Promise<void>;
	askInNewThread: (userInput: string) => Promise<void>;
	isEnabled: boolean;
}

export const AiAssistantControllerContext = React.createContext<AiAssistantControllerContextValue | undefined>(
	undefined,
);

export const useAiAssistantControllerContext = () => useContextOrThrow(AiAssistantControllerContext);

export const useOptionalAiAssistantControllerContext = () => React.useContext(AiAssistantControllerContext);
